import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"; // Import FontAwesome icon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Form, Input, Row, Select, Typography } from "antd";
import axios from "axios";
import { message } from "components/Messages/Messages";
import { isCompanyUser, useLoginContext } from "contexts/LoginContext/LoginContext";
import { StudyProgram } from "interfaces/students";
import { StudentUser, UpdateStudentUser /* , User */ } from "interfaces/users";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ChangePassword from "./ChangePassword";

const { Title } = Typography;

const { Option } = Select;

const EditProfile = () => {
  const { currentUser } = useLoginContext();
  const [studyPrograms, setStudyPrograms] = useState<StudyProgram[]>([]);
  const [changePassword, setChangePassword] = useState<boolean>(false);

  const [form] = Form.useForm();
  const history = useHistory();

  useEffect(() => {
    axios.get<StudyProgram[]>("/students/study-program/").then(response => setStudyPrograms(response.data));
  }, [currentUser]);

  if (isCompanyUser(currentUser) || !currentUser) return null;

  const updateStudent = async (values: UpdateStudentUser) => {
    try {
      await axios.put<StudentUser>(`/students/${currentUser?.id}/`, {
        ...currentUser,
        first_name: values.first_name,
        last_name: values.last_name,
        mobile_number: values.mobile_number,
        allergies: values.allergies,
        updated_at: new Date().toISOString(),
      });
      history.push("/student-profile/");
      message("success", "Profil oppdatert");
      currentUser.first_name = values.first_name;
      currentUser.last_name = values.last_name;
      currentUser.mobile_number = values.mobile_number;
      currentUser.allergies = values.allergies;
    } catch (error) {
      message("error", "Kunne ikke oppdatere profil");
    }
  };

  const handleButtonClick = () => {
    history.push("/student-profile");
  };

  return (
    <Card style={{ width: "80%", margin: "auto", display: "flex", justifyContent: "center" }}>
      <Form form={form} layout="vertical" requiredMark onFinish={updateStudent}>
        <Row>
          <Col span={2}>
            <Button style={{ width: "70%", height: "3rem", fontSize: "1.5rem" }} onClick={handleButtonClick}>
              <FontAwesomeIcon icon={faArrowLeft} />
            </Button>
          </Col>

          <Col>
            <Title>Rediger profil</Title>
          </Col>
        </Row>
        <br />

        <Row gutter={[16, 1]}>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label="Fornavn"
              name="first_name"
              initialValue={currentUser.first_name}
              rules={[{ required: true, message: "Vennligst skriv inn fornavn" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label="Etternavn"
              name="last_name"
              initialValue={currentUser.last_name}
              rules={[{ required: true, message: "Vennligst skriv inn etternavn" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label="Mobilnummer"
              name="mobile_number"
              initialValue={currentUser.mobile_number}
              rules={[{ required: true, message: "Vennligst skriv inn telefonnummer" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item label="Epost" name="email" initialValue={currentUser.email}>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label="Linje"
              name="studyProgramme"
              initialValue={currentUser.study_programme}
              tooltip="Har du byttet linje eller årskull? Send en mail med dokumentasjon til it@bindeleddet.no"
            >
              <Select disabled>
                {studyPrograms.map(program => {
                  return (
                    <Option value={program.id} key={program.id}>
                      {program.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item label="Årskull" name="year" initialValue={currentUser.year_level}>
              <Select disabled>
                <Option value={1}>1. klasse</Option>
                <Option value={2}>2. klasse</Option>
                <Option value={3}>3. klasse</Option>
                <Option value={4}>4. klasse</Option>
                <Option value={5}>5. klasse</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24}>
            {/* TODO sørg for at ikke brukernavn fylles inn som allergi automatisk */}
            <Form.Item
              label="Allergier"
              name="allergies"
              initialValue={currentUser.allergies ?? ""}
              tooltip="Hvis du har flere allergier, skill med komma."
            >
              <Input autoComplete="allergies" />
            </Form.Item>
          </Col>
          {/*
          <Col xs={24} sm={24} md={12}>
            <Checkbox>
              <Text style={{ fontSize: "1.1em" }}>Bindeleddet NTNU mailliste</Text>
              <Paragraph>
                Bindeleddet NTNU sender deg informasjon om kommende presentasjoner og andre aktiviteter i Bindeleddet
                NTNUs regi
              </Paragraph>
            </Checkbox>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Checkbox>
              <Text style={{ fontSize: "1.1em" }}>Bedrift mailliste</Text>
              <Paragraph>Bedrifter kan sende deg informasjon om sommerjobber, stillinger og lignende</Paragraph>
            </Checkbox>
          </Col>
              */}
        </Row>
        <br />
        <Row gutter={[16, 1]}>
          <Col xs={12} sm={12} md={12}>
            <Button onClick={() => setChangePassword(!changePassword)}>Endre passord?</Button>
          </Col>
          <Col xs={12} sm={12} md={12} style={{ textAlign: "right" }}>
            <Form.Item>
              <Button size="large" type="primary" htmlType="submit">
                Lagre
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <ChangePassword open={changePassword} setOpen={setChangePassword} userId={currentUser.id} />
    </Card>
  );
};

export default EditProfile;
